const FETCH_VISIBILITY_PENDING = "VISIBILITY_FETCH_VISIBILITY_PENDING";
const FETCH_VISIBILITY_SUCCESS = "VISIBILITY_FETCH_VISIBILITY_SUCCESS";
const FETCH_VISIBILITY_ERROR = "VISIBILITY_FETCH_VISIBILITY_ERROR";

const FETCH_ALL_PENDING = "VISIBILITY_FETCH_ALL_VISIBILITY_PENDING";
const FETCH_ALL_SUCCESS = "VISIBILITY_FETCH_ALL_VISIBILITY_SUCCESS";
const FETCH_ALL_ERROR = "VISIBILITY_FETCH_ALL_VISIBILITY_ERROR";

const FETCH_ALL_ROLES_PENDING = "VISIBILITY_FETCH_ALL_ROLES_VISIBILITY_PENDING";
const FETCH_ALL_ROLES_SUCCESS = "VISIBILITY_FETCH_ALL_ROLES_VISIBILITY_SUCCESS";
const FETCH_ALL_ROLES_ERROR = "VISIBILITY_FETCH_ALL_ROLES_VISIBILITY_ERROR";

const EDIT_PENDING = "VISIBILITY_EDIT_PENDING";
const EDIT_DONE = "VISIBILITY_EDIT_DONE";

const SET_FILTER = "VISIBILITY_SET_FILTERS";

export default {
  FETCH_VISIBILITY_PENDING,
  FETCH_VISIBILITY_SUCCESS,
  FETCH_VISIBILITY_ERROR,
  FETCH_ALL_PENDING,
  FETCH_ALL_SUCCESS,
  FETCH_ALL_ERROR,
  FETCH_ALL_ROLES_PENDING,
  FETCH_ALL_ROLES_SUCCESS,
  FETCH_ALL_ROLES_ERROR,
  EDIT_PENDING,
  EDIT_DONE,
  SET_FILTER,
};
